import { HttpService, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { extractFilenameFromHeaders, MS_PER_MINUTE } from '@skylab-shared/utils';
import { AxiosResponse } from 'axios';
import { ExportQueryParameters } from '../../common/export/export-query.parameters';
import { ExportResult } from '../../common/export/export-query.result';
import { ExportQuery } from '../../common/export/export.query-base';


export interface ClientsExportParameters extends ExportQueryParameters { search: string; }

export class ClientsExportQuery extends ExportQuery<ExportResult> {
    public constructor(parameters: ExportQueryParameters) {
        super(parameters);
    }
}

export class ClientsExportQueryHandlerBase implements QueryHandler<ClientsExportQuery, ExportResult> {
    private static Url = TaggedUrl.join('clients/csv/export', [Tags.Api]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync({ parameters }: ClientsExportQuery): Promise<ExportResult> {
        const requestData = {
            compress: parameters.compress,
            password: parameters.password,
            config: {
                orderBy: JSON.stringify(parameters.orderBy),
                parameters: JSON.stringify(parameters.parameters),
                columns: parameters.columns
            }
        };

        const response = await this.http.post<Blob>(ClientsExportQueryHandlerBase.Url, requestData, { responseType: 'blob', timeout: 3 * MS_PER_MINUTE });

        return {
            file: response.data,
            filename: extractFilenameFromHeaders(<AxiosResponse>response) ?? ''
        };
    }
}
